import { render } from "./coach-request-coaching.vue?vue&type=template&id=4efd950c"
import script from "./coach-request-coaching.vue?vue&type=script&lang=js"
export * from "./coach-request-coaching.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__